import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller('ContractPositionsReportCtrl', ContractPositionsReportCtrl);

    /**
     *
     * @author sosoehngen.prv
     * @ngInject
     */
    function ContractPositionsReportCtrl(
        DATES,
        COLUMN_FILTER,
        authService,
        reportingStorageService,
        Fcfs,
        paginationService
    ) {
        var vm = this,
            lastSortColumn = 'legalContractPositionId';

        vm.DATES = DATES;
        vm.COLUMN_FILTER = COLUMN_FILTER;
        vm.isLoggedIn = authService.isLoggedIn();
        vm.uiLoading = true;
        vm.contractPositions = {};
        vm.colFiltOptRuntime = {};
        vm.pagingSetting = {};
        vm.paginator = {
            currentPage: 0
        };
        vm.showFav = vm.isLoggedIn;
        vm.showAll = !vm.isLoggedIn;
        vm.reverseOrder = false;
        vm.sortColumn = lastSortColumn;
        vm.changePageNumber = changePageNumber;
        vm.getContractPositions = getContractPositions;
        vm.changeSorting = changeSorting;
        vm.setToStartPage = setToStartPage;

        initParameter();

        function initParameter() {
            var sessionFilters = reportingStorageService.fetchFromSession(
                'reportFilter-contractPositionsReport-colFiltOpts'
            );

            if (sessionFilters) {
                vm.colFiltOpts = sessionFilters;
            } else {
                vm.colFiltOpts = {
                    favoritesOnly: true
                };
            }

            var sessionParam = reportingStorageService.fetchFromSession(
                'reportFilter-contractPositionsReport-param'
            );

            if (sessionParam) {
                vm.param = sessionParam;
            } else {
                vm.param = {
                    pageNumber: 1,
                    start: vm.paginator.currentPage,
                    sortAscending: vm.reverseOrder,
                    sortColumn: vm.sortColumn
                };
            }
        }

        function getContractPositions() {
            vm.uiLoading = true;

            storeParameters();

            var param = {};
            angular.extend(param, vm.param);
            angular.extend(param, vm.pagingSetting);
            angular.extend(param, vm.colFiltOpts);

            Fcfs.legalContractPositions(
                param,
                function (res) {
                    vm.contractPositions = res;
                    vm.uiLoadingError = false;
                },
                function () {
                    vm.uiLoadingError = true;
                }
            ).$promise.finally(function () {
                vm.uiLoading = false;
            });
        }

        function storeParameters() {
            reportingStorageService.storeToSession(
                'reportFilter-contractPositionsReport-param',
                vm.param
            );
            reportingStorageService.storeToSession(
                'reportFilter-contractPositionsReport-colFiltOpts',
                vm.colFiltOpts
            );
        }

        function setToStartPage() {
            paginationService.setCurrentPage(
                vm.paginator.identificationName
                    ? vm.paginator.identificationName
                    : '__default',
                1
            );
        }

        function changeSorting(orderBy) {
            if (lastSortColumn === orderBy) {
                vm.param.sortAscending = !vm.param.sortAscending;
            } else {
                lastSortColumn = orderBy;
                vm.param.sortColumn = orderBy;
                vm.param.sortAscending = true;
            }
            getContractPositions();
        }

        function changePageNumber(newPageNumber) {
            var newPaginatorStart =
                (newPageNumber - 1) * vm.pagingSetting.pageSize;
            vm.param.pageNumber = newPageNumber;
            if (newPaginatorStart !== vm.param.start) {
                vm.param.start = newPaginatorStart;
                getContractPositions();
            }
        }
    }
})();
